import { Tab, TabsGroup } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ExpertBalanceSheetTab } from '../../types/expertBalanceSheetView'
import * as Styled from './styles'

interface ExpertBalanceSheetTabsProps {
  activeTab: ExpertBalanceSheetTab
  onTabChange: (tab: ExpertBalanceSheetTab) => void
}

export const ExpertBalanceSheetTabs = ({ activeTab, onTabChange }: ExpertBalanceSheetTabsProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Styled.ExpertBalanceSheetTabsWrapper>
      <TabsGroup>
        <Tab
          onClick={() => onTabChange(ExpertBalanceSheetTab.Assets)}
          active={activeTab === ExpertBalanceSheetTab.Assets}
        >
          {t('expert_balance_sheet.tab.assets')}
        </Tab>
        <Tab
          onClick={() => onTabChange(ExpertBalanceSheetTab.LiabilitiesAndEquity)}
          active={activeTab === ExpertBalanceSheetTab.LiabilitiesAndEquity}
        >
          {t('expert_balance_sheet.tab.liabilities_and_equity')}
        </Tab>
      </TabsGroup>
    </Styled.ExpertBalanceSheetTabsWrapper>
  )
}
